import { theme } from "components/styles";
import { useMediaQuery } from "react-responsive";
import { useTheme } from "styled-components";

/**
 * useMediaView - 여러 미디어 쿼리를 쉽게 활용할 수 있는 훅
 * @param {keyof typeof theme.media} queryKey - 사용할 미디어 쿼리의 테마 키 값
 * @returns {boolean} - 해당 미디어 쿼리가 활성화된지 여부
 */

const useMediaView = (queryKey: keyof typeof theme.media) => {
  const theme = useTheme();

  // 미디어 쿼리 키가 테마에 존재하는지 확인

  const mediaQueryRegex = /\(([^()]+)\)/;
  const query = theme.media[queryKey].match(mediaQueryRegex);

  if (!query) {
    throw new Error(`Media query '${queryKey}' is not matched in the theme.`);
  }

  const isMatching = useMediaQuery({
    query: query[0],
  });

  return isMatching;
};

export default useMediaView;
